import React, { Component } from 'react';
import ReactTelephoneInput from 'views/ui/phone-input';

class PhoneInput extends Component {
  handleInputChange = (telNumber, _selectedCountry) => {
    this.props.form.setFieldValue('phone', telNumber);
  };

  render() {
    return (
      <ReactTelephoneInput
        onChange={this.handleInputChange}
        value={this.props.phone}
      />
    );
  }
}

export default PhoneInput;
